import { CSSProperties, ChangeEvent, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { CustomInput } from '../../shared/uiComponents';
import { FilterIcon, SearchIcon } from '../../shared/Assets/svg';
import { PRIMARY } from '../../shared/Helpers/colors';

const SearchBar = ({
	label,
	hasFilter = false,
	activeFilterCount = 0,
	style = { marginTop: '28px' },
}: {
	activeFilterCount?: number;
	hasFilter?: boolean;
	label?: string;
	style?: CSSProperties;
}) => {
	const [params, setParams] = useSearchParams();
	const [startSearch, setStartSearch] = useState<string | null>('');

	const onSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value;

		setStartSearch(value);
	};

	const toggleFilterHandler = () => {
		const filterParams = params.get('filter') === 'open' ? 'close' : 'open';
		params.set('filter', filterParams);
		setParams(params, { replace: true });
	};

	useEffect(() => {
		if (typeof startSearch !== 'string') return;
		const timeout = setTimeout(() => {
			const previousSearchValue = params.get('search');
			if (previousSearchValue === startSearch) return;
			params.set('search', startSearch);
			params.set('page', '1');
			setParams(params, { replace: true });
		}, 2000);

		// TODO - return void as in return () => void clearTimeout(timeout);
		// eslint-disable-next-line
		return () => clearTimeout(timeout);
	}, [params, setParams, startSearch]);

	return (
		<CustomInput
			label={label}
			value={startSearch}
			onChange={onSearchChange}
			placeholder="Search..."
			style={style}
			startAdornment={<SearchIcon title="Search" size={25} />}
			endAdornment={
				hasFilter && (
					<div style={{ position: 'relative', cursor: 'pointer' }} onClick={toggleFilterHandler}>
						<FilterIcon title="Filter" size={20} />
						{activeFilterCount > 0 && (
							<div
								style={{
									position: 'absolute',
									top: -4,
									right: -6,
									backgroundColor: PRIMARY.BASE,
									color: '#fff',
									borderRadius: '50%',
									width: 16,
									height: 16,
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									fontSize: 10,
									fontWeight: 600,
									lineHeight: 1,
								}}
							>
								{activeFilterCount}
							</div>
						)}
					</div>
				)
			}
		/>
	);
};

export default SearchBar;
